// PACKAGES
import jwt_decode from 'jwt-decode' // eslint-disable-line
import Cookies from 'js-cookie/src/js.cookie'
import * as psl from 'psl'
// UTILS
import { MAGIC_TOKEN } from '../util/consts'
// HTTP
import Applications from '../http/applications'

const getDomain = () => {
  return psl.parse(window.location.hostname).domain
}

export default class MagicToken {
  static removeJwt () {
    Cookies.remove(MAGIC_TOKEN, { domain: getDomain() })
  }

  static getJwt () {
    return Cookies.get(MAGIC_TOKEN)
  }

  static async retrieveJwt (token) {
    if (token) {
      const newJwt = (await Applications.getMagicJwtFromToken(token)).data.access_token
      Cookies.set(MAGIC_TOKEN, newJwt, { domain: getDomain(), expires: 1 }) // expires in one day, matching jwt expiration
      return newJwt
    } else {
      return Promise.reject(new Error('invalid token'))
    }
  }
}
